module.exports = "../dist/img/product-detail-1-21.6cb9.jpg";